import { useState } from "react";
import { GoogleLoginButton } from "react-social-login-buttons";
import { useFormContext } from "react-hook-form";
import { baseURL } from "../../shared/env";

function Dv360() {
    const [authorized, setAuthorized] = useState(false);
    const { setValue } = useFormContext();

    const handleGoogleLogin = () => {
        const params = new URLSearchParams({
          client_id:
            "581251533215-knco944slgqrh2vp8tk7alidp348cn4g.apps.googleusercontent.com",
          redirect_uri: `${baseURL}`,
          response_type: "code",
          scope: "https://www.googleapis.com/auth/display-video email profile",
          access_type: "offline",
          prompt: "consent",
        });

        const popup = window.open(
            `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`,
            "googleLogin",
            "width=600,height=700"
        );

        const interval = setInterval(() => {
            try {
                if (!popup || popup.closed) {
                    clearInterval(interval);
                    return;
                }

                const popupUrl = new URL(popup.location.href);
                const code = popupUrl.searchParams.get("code");

                if (code) {
                    setValue("token", code);
                    setAuthorized(true);
                    popup.close();
                    clearInterval(interval);
                }
            } catch (err) {
            }
        }, 500);
    };

    return (
        <div>
            {!authorized ? (
                <div>
                    <div className="create-destination__platform-header">
                        Authorize your Google DV360 connection:
                    </div>
                    <GoogleLoginButton onClick={handleGoogleLogin} />
                </div>
            ) : (
                <div>
                    <div className="create-destination__platform-header">Your Dv360 authorization code has been obtained</div>
                </div>
            )}
        </div>
    );
}

export default Dv360;